import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var VectorSource = /*#__PURE__*/function () {
  function VectorSource(vector, x, y, z) {
    _classCallCheck(this, VectorSource);

    _defineProperty(this, "vectorLayerCache", {});

    this.x = x;
    this.y = y;
    this.z = z;
    this.vectorTile = vector;
  }

  _createClass(VectorSource, [{
    key: "getTileData",
    value: function getTileData(sourceLayer) {
      if (!sourceLayer || !this.vectorTile.layers[sourceLayer]) {
        return [];
      } // 优先走缓存


      if (this.vectorLayerCache[sourceLayer]) {
        return this.vectorLayerCache[sourceLayer];
      }

      var vectorTile = this.vectorTile.layers[sourceLayer];
      return vectorTile.features;
    }
  }, {
    key: "getFeatureById",
    value: function getFeatureById() {
      throw new Error('Method not implemented.');
    }
  }]);

  return VectorSource;
}();

export { VectorSource as default };